import {
  Box,
  Button,
  Card,
  ChakraProvider,
  Grid,
  HStack,
  Stack,
  Tab,
  TabList,
  Tabs,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentProfile } from "../../ContextWrapper";
import IndustryInsightView from "./industryInsights";
import RevenueDropdown from "./revenueDropdown";
import ClientDashboardLayout from "./dashboardLayout";
import theme from "../../theme";
import { Menu } from "react-feather";
import { LockIcon } from "@chakra-ui/icons";
import axios from "axios";

const IndustryInsightsSelection = () => {
  const { profile } = useCurrentProfile();

  const [activeCustomer, setActiveCustomer] = useState(null);

  useEffect(() => {
    if (!profile) return;

    const storedId = sessionStorage.getItem("selectedCustomerId");
    if (!storedId) return;

    if (profile.type !== "admin") {
      const customer =
        profile.customers.find((c) => c.id.toString() === storedId) ||
        profile.customers[0] ||
        null;
      setActiveCustomer(customer);
      return;
    }

    const fetchCustomer = async () => {
      try {
        const res = await axios.get(
          `/api/v2/customers/${storedId}/`,
          { headers: { "Content-Type": "application/json" } },
          { withCredentials: true }
        );
        setActiveCustomer(res.data);
      } catch (err) {
        console.error("Error fetching admin customer:", err);
      }
    };

    fetchCustomer();
  }, [profile]);

  useEffect(() => {
    const handleSelectedChange = async () => {
      const storedId = sessionStorage.getItem("selectedCustomerId");
      if (!storedId) return;

      if (profile.type !== "admin") {
        const found = profile.customers.find(
          (c) => c.id.toString() === storedId
        );
        if (found) setActiveCustomer(found);
      } else {
        try {
          const res = await axios.get(`/api/v2/customers/${storedId}/`, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          });
          setActiveCustomer(res.data);
        } catch (err) {
          console.error("Error fetching admin customer:", err);
        }
      }
    };

    window.addEventListener("selectedCustomerId-changed", handleSelectedChange);
    return () => {
      window.removeEventListener(
        "selectedCustomerId-changed",
        handleSelectedChange
      );
    };
  }, [profile]);

  const customer_type = activeCustomer?.customer_type;
  const customer_id = activeCustomer?.id;

  const [insightDate, setInsightDate] = useState();
  const [revenueGroup, setRevenueGroup] = useState("fiftyk");

  const [isMobile] = useMediaQuery("(max-width: 1280px)");
  const location = useLocation();
  const navigate = useNavigate();

  const getTabFromUrl = (path) => {
    if (path.includes("/average")) return "average";
    if (path.includes("/top-one")) return "topOne";
    if (path.includes("/top-ten")) return "topTen";
    return "average";
  };

  const [tab, setTab] = useState(getTabFromUrl(location.pathname));

  useEffect(() => {
    const urlTab = getTabFromUrl(location.pathname);
    if (tab !== urlTab) setTab(urlTab);
  }, [location.pathname, tab, profile?.type]);

  const tabIndex =
    tab === "topTen" ? 1 : tab === "topOne" ? 0 : tab === "average" ? 2 : 0;

  const handleTabChange = (index) => {
    const newTab = index === 1 ? "topTen" : index === 0 ? "topOne" : "average";
    setTab(newTab);

    navigate(
      `/industry-insights/${
        newTab === "average"
          ? "average"
          : newTab === "topOne"
          ? "top-one"
          : "top-ten"
      }`
    );
  };

  return (
    <ClientDashboardLayout>
      <ChakraProvider theme={theme}>
        <Stack bg="#F4F4F2" minH={"100vh"}>
          {customer_type === "trial" && (
            <Box
              position="fixed"
              top="0"
              left="0"
              w="100%"
              h="100%"
              bg="rgba(255, 255, 255, 0.7)"
              backdropFilter="blur(13px)"
              zIndex="500"
              display="flex"
              flexDir={"column"}
              alignItems="center"
              justifyContent="center"
              minHeight={"100vh"}
              maxHeight={"100%"}
            >
              <LockIcon></LockIcon>
              <Text fontSize="lg" fontWeight="800" color="gray.700" p={2}>
                Upgrade to Unlock Industry Insights
              </Text>
            </Box>
          )}
          {isMobile && (
            <Card
              position="fixed"
              zIndex={999}
              borderRadius={0}
              h="72px"
              borderBottom="1px solid #e0e0e0"
              width="100%"
            >
              <HStack
                justifyContent="space-between"
                alignItems="center"
                h={"100%"}
                w="100%"
                px={4}
              >
                <Button
                  bg="white"
                  _hover={{ color: "white" }}
                  _active={{ color: "white" }}
                  w="50px"
                  h="50px"
                  p={2}
                  onClick={() => {
                    window.dispatchEvent(new Event("sidebar:expand"));
                  }}
                >
                  <Menu
                    style={{ width: "50px", height: "100%" }}
                    color="black"
                  />
                </Button>

                <HStack>
                  <RevenueDropdown
                    revenueGroup={revenueGroup}
                    setRevenueGroup={setRevenueGroup}
                  />
                </HStack>
              </HStack>
            </Card>
          )}
          <Card
            borderRadius={0}
            h={isMobile ? "50px" : "72px"}
            borderBottom="1px solid #e0e0e0"
            mt={isMobile ? "72px" : "0px"}
            zIndex={50}
            position="fixed"
            width={isMobile ? "100vw" : "auto"}
            display="flex"
            alignItems="center"
          >
            <Tabs
              index={tabIndex}
              onChange={handleTabChange}
              variant="unstyled"
              width="100%"
            >
              <Grid
                templateColumns={isMobile ? "1fr" : "1fr 2fr 275fr"}
                alignItems="center"
                p={!isMobile ? "0px 20px 0px" : "0px 10px 0px"}
                h={isMobile ? "50px" : "72px"}
              >
                <TabList
                  display="flex"
                  alignItems="center"
                  h={isMobile ? "50px" : "74px"}
                  overflowX="auto"
                  minW={!isMobile ? "500px" : "auto"}
                  width={isMobile ? "100%" : "auto"}
                  sx={{
                    overflowX: "auto",
                    "::-webkit-scrollbar": { display: "none" },
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                  }}
                >
                  <Tab
                    _focus={{
                      outline: "none",
                      border: "none",
                      boxShadow: "none",
                    }}
                    _selected={{
                      borderBottom: "3px solid #536DEC",
                      color: "#536DEC",
                      fontWeight: 700,
                    }}
                    cursor="pointer"
                    _active={{ background: "none" }}
                    width={isMobile ? "115px" : "135px"}
                    h="100%"
                    p={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    whiteSpace="nowrap"
                    m={0}
                  >
                    <Text
                      fontSize={isMobile ? "13px" : "16px"}
                      margin="0"
                      p="0px 8px"
                    >
                      Top 1% Performers
                    </Text>
                  </Tab>

                  <Tab
                    _focus={{
                      outline: "none",
                      border: "none",
                      boxShadow: "none",
                    }}
                    _selected={{
                      borderBottom: "3px solid #536DEC",
                      color: "#536DEC",
                      fontWeight: 700,
                    }}
                    cursor="pointer"
                    _active={{ background: "none" }}
                    h="100%"
                    width={isMobile ? "130px" : "160px"}
                    p={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    whiteSpace="nowrap"
                    m={0}
                  >
                    <Text fontSize={isMobile ? "13px" : "16px"} margin="0">
                      Top 10% Performers
                    </Text>
                  </Tab>

                  <Tab
                    _focus={{
                      outline: "none",
                      border: "none",
                      boxShadow: "none",
                    }}
                    _selected={{
                      borderBottom: "3px solid #536DEC",
                      color: "#536DEC",
                      fontWeight: 700,
                    }}
                    cursor="pointer"
                    _active={{ background: "none" }}
                    h="100%"
                    width={isMobile ? "125px" : "148px"}
                    p={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    whiteSpace="nowrap"
                    m={0}
                  >
                    <Text
                      fontSize={isMobile ? "13px" : "16px"}
                      margin="0"
                      p="0px 8px"
                    >
                      Average Performers
                    </Text>
                  </Tab>
                </TabList>

                {!isMobile && (
                  <Stack
                    gridColumn={9}
                    textAlign="right"
                    justifyContent="center"
                    mb="3px"
                  >
                    <HStack>
                      <RevenueDropdown
                        revenueGroup={revenueGroup}
                        setRevenueGroup={setRevenueGroup}
                        selectable={tab === "average"}
                      />
                      <Box
                        display="flex"
                        alignItems="center"
                        width="200px"
                        borderWidth="1px"
                        justifyContent="center"
                        height="40px"
                        borderRadius="6px"
                      >
                        <Text textAlign="center" fontSize="16px">
                          {insightDate}
                        </Text>
                      </Box>
                    </HStack>
                  </Stack>
                )}
              </Grid>
            </Tabs>
          </Card>

          {tab === "topTen" ? (
            <IndustryInsightView
              customer_id={customer_id}
              performanceGroup="ten"
              revenueGroup={revenueGroup}
              setInsightDate={setInsightDate}
            />
          ) : tab === "topOne" ? (
            <IndustryInsightView
              customer_id={customer_id}
              performanceGroup="one"
              revenueGroup={revenueGroup}
              setInsightDate={setInsightDate}
            />
          ) : (
            <IndustryInsightView
              customer_id={customer_id}
              performanceGroup="average"
              revenueGroup={revenueGroup}
              setInsightDate={setInsightDate}
            />
          )}
        </Stack>
      </ChakraProvider>
    </ClientDashboardLayout>
  );
};

export default IndustryInsightsSelection;
